var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpgLeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334,5.333C16.267,5.333 18.667,7.733 18.667,10.667C18.667,13.6 16.267,16 13.334,16C10.4,16 8,13.6 8,10.667C8,7.733 10.4,5.333 13.334,5.333ZM22.667,28L25.067,30.36C25.734,31.027 26.667,30.493 26.667,29.707V24L30.4,19.467C30.549,19.269 30.639,19.033 30.662,18.786C30.684,18.54 30.637,18.292 30.526,18.07C30.416,17.849 30.245,17.663 30.035,17.532C29.824,17.402 29.581,17.333 29.334,17.333H20C18.934,17.333 18.267,18.667 18.934,19.467L22.667,24V28ZM20,24.933L16.934,21.2C16.4,20.533 16.134,19.733 16.134,18.933C15.2,18.667 14.267,18.667 13.334,18.667C7.467,18.667 2.667,21.067 2.667,24V26.667H20V24.933Z",
    fill: "#BD7EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpgLeads);
export default __webpack_public_path__ + "static/media/spgLeads.3215dbb5d119c1ffeadaf790aa6b292f.svg";
export { ForwardRef as ReactComponent };